<template>
  <v-list
    data-qa="reviews_filter_list"
    :class="{ 'pb-3': isMobile }"
  >
    <template
      v-for="review in reviewsList"
    >
      <v-list-item
        v-if="!review.disabled"
        :key="review.value"
        :disabled="review.disabled"
        :class="{ 'bg-primary': review.isActive }"
        :data-qa="`reviews_filter_list_item_${review.value}`"
        @click="handleClickItem(review)"
      >
        <div class="d-flex justify-space-between align-center w-100">
          <div
            data-qa="reviews_filter_title"
            class="text-body-1"
            :class="{
              'text--text': !review.isActive && !review.disabled,
              'primary--text ': review.isActive,
            }"
          >
            {{ review.title }}
          </div>
          <div
            data-qa="reviews_filter_amount"
            class="text-caption text--text px-2 py-1 rounded-sm"
            :class="review.backgroundColorLabel"
          >
            {{ review.amount }}
          </div>
        </div>
      </v-list-item>
    </template>
  </v-list>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { Review } from 'www/vue_components/common/ReviewsFilter/types'

type Emits = {
  (e: 'click:item', item: Review): void // eslint-disable-line
}

const emit = defineEmits<Emits>()
const props = withDefaults(defineProps<{ reviewsList: Array<Review> }>(), { reviewsList: () => [] })
const reviewsList = ref(props.reviewsList)
const isMobile = window.MOBILE_VERSION

function handleClickItem(item: Review) {
  if (item.isActive) {
    return
  }

  reviewsList.value.forEach((i: Review) => {
    i.isActive = false
  })

  item.isActive = true

  emit('click:item', item)
}
</script>
